import React from "react";

const LoadingSpinner = () => {
  return (
    <div className="flex items-center justify-center min-h-screen bg-neutral-50">
      <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-blue-500"></div>
      <p className="ml-4 text-lg text-neutral-700">Carregando...</p>
    </div>
  );
};

export default LoadingSpinner;
